import Cookies from 'js-cookie';

export const getCookies = () =>
  Cookies.get('voyagerInputs') === undefined ? {} : JSON.parse(Cookies.get('voyagerInputs'));
